<template>
  <div class="register">
    <!--账号注册  -->
    <div class="register-content">
      <Form ref="formValidate" :model="formValidate" :rules="ruleValidate">
        <h3 class="register-title">
          {{
            $t("permission_configuration_management.account.accountRegister")
          }}
        </h3>
        <div class="overflow-register">
          <!-- 用户名 -->
          <FormItem prop="name" class="register-user">
            <Icon type="md-person" class="register-icon" />
            <input
              v-model="formValidate.name"
              :placeholder="
                $t('permission_configuration_management.register.UserName')
              "
              autocomplete="off"
            />
          </FormItem>
          <!-- 全名 -->
          <FormItem prop="fullName" class="register-user">
            <Icon type="md-person" class="register-icon" />
            <input
              v-model="formValidate.fullName"
              :placeholder="
                $t('permission_configuration_management.register.FullName')
              "
              autocomplete="off"
            />
          </FormItem>
          <!-- 公司 -->
          <FormItem prop="companyId" class="register-user">
            <Icon
              type="md-laptop"
              class="register-icon"
              style="margin-top: 8px;"
            />
            <Select
              v-model="formValidate.companyId"
              style="width:400px;margin-top: 10px;margin-left:10px;"
              :placeholder="
                $t('permission_configuration_management.register.Company')
              "
            >
              <Option
                :value="item.id"
                v-for="(item, index) in companyIdList"
                v-bind:key="index"
                >{{ item.companyName }}
              </Option>
            </Select>
          </FormItem>
          <!-- 部门 -->
          <FormItem prop="department" class="register-user">
            <Icon
              type="ios-filing"
              class="register-icon"
              style="margin-top: 8px;"
            />
            <Select
              v-model="formValidate.department"
              style="width:400px;margin-top: 10px;margin-left:10px;"
              @on-change="changeDepartment"
              :placeholder="
                $t('permission_configuration_management.register.Department')
              "
            >
              <Option
                :value="item.id"
                v-for="(item, index) in departmentList"
                v-bind:key="index"
                >{{ item.name }}
              </Option>
            </Select>
          </FormItem>
          <!-- 职务 -->
          <FormItem prop="position" class="register-user">
            <Icon
              type="md-ribbon"
              class="register-icon"
              style="margin-top: 8px;"
            />
            <Select
              v-model="formValidate.position"
              style="width:400px;margin-top: 10px;margin-left:10px;"
              :placeholder="
                $t('permission_configuration_management.register.Position')
              "
            >
              <Option
                :value="item.id"
                v-for="(item, index) in positionList"
                v-bind:key="index"
                >{{ item.name }}
              </Option>
            </Select>
          </FormItem>
          <!-- 邮箱 -->
          <FormItem prop="email" class="register-user">
            <Icon type="md-mail" class="register-icon" />
            <input
              v-model="formValidate.email"
              :placeholder="
                $t('permission_configuration_management.register.Mailbox')
              "
            />
          </FormItem>
          <!-- 密码 -->
          <FormItem prop="password" class="register-user">
            <Icon type="md-lock" class="register-icon" />
            <input
              v-model="formValidate.password"
              :placeholder="
                $t('permission_configuration_management.register.Password')
              "
              type="password"
              autocomplete="new-password"
            />
          </FormItem>
          <!-- 确认密码 -->
          <FormItem prop="confirmPassword" class="register-user">
            <Icon type="md-lock" class="register-icon" />
            <input
              v-model="formValidate.confirmPassword"
              :placeholder="
                $t(
                  'permission_configuration_management.register.ConfirmPassword'
                )
              "
              type="password"
              autocomplete="new-password"
            />
          </FormItem>
          <!-- 是否开启短信验证 -->
          <div style="display:flex">
            <div style="flex:1">
              <Icon type="md-mail-open" class="msg-open" />
            </div>
            <div style="flex:9">
              <FormItem
                :label="
                  $t('permission_configuration_management.user.SMSVerification')
                "
                prop="msgCode"
              >
                <RadioGroup v-model="msgCode">
                  <Radio :label="$t('common.yes')"></Radio>
                  <Radio :label="$t('common.no')"></Radio>
                </RadioGroup>
              </FormItem>
            </div>
          </div>

          <!-- 开启短信验证 手机号为必填项 -->
          <FormItem
            prop="phone"
            class="register-user"
            v-if="msgCode == $t('common.yes')"
          >
            <!-- <Icon type="md-phone-portrait" class="register-icon" /> -->
            <div class="tel-container">
              <Select v-model="areaCode" placeholder="+86">
                <Option
                  :value="a.phone_code"
                  :key="index"
                  v-for="(a, index) in AreaCodeArr"
                  :label="'+' + a.phone_code"
                >
                  <span
                    >{{ "+" + a.phone_code }}&nbsp;{{ a.chinese_name }} (
                    {{ a.english_name }} )
                  </span>
                </Option>
              </Select>
              <input
                v-model="formValidate.phone"
                type="number"
                :placeholder="
                  $t('permission_configuration_management.smsLogin.plaTelPhone')
                "
              />
            </div>
          </FormItem>
          <!-- 开启短信验证 短信验证码吗为必填项 -->
          <FormItem
            class="register-user tel-login-user"
            v-if="msgCode == $t('common.yes')"
          >
            <Icon type="md-lock" class="register-icon" />
            <input
              v-model="formValidate.code"
              type="number"
              :placeholder="
                $t(
                  'permission_configuration_management.smsLogin.plaVerificationCode'
                )
              "
              :style="$i18n.locale == 'zh' ? 'width:310px' : 'width:250px'"
            />
            <Button
              type="text"
              :disabled="disabled"
              @click="sendCode"
              class="btn-text"
            >
              {{ text }}
            </Button>
          </FormItem>
        </div>
        <Button type="primary" @click="register('formValidate')">{{
          $t("permission_configuration_management.register.Register")
        }}</Button>
        <div class="registers" @click="login()">
          {{
            $t(
              "permission_configuration_management.register.ExistingAccountLogin"
            )
          }}
        </div>
      </Form>
    </div>
  </div>
</template>
<script>
import { setCookie, getCookie } from "../../../../utils/cookieUtil.js";
import AreaCode from "@/utils/AreaCode";
import log from "../../../../api/log.js";
var tableCaseVue = {};
export default {
  data() {
    const pwdValidate = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(this.$t("permission_configuration_management.user.passwordRequired")));
      } else {
        callback();
      }
    };
    const pwdCheckValidate = (rule, value, callback) => {
      if (this.formValidate.password != "" && value == "") {
        callback(new Error(this.$t("permission_configuration_management.user.confirmPasswordRequired")));
      } else if (this.formValidate.password != value) {
        callback(new Error(this.$t("permission_configuration_management.user.passwordMismatch")));
      } else {
        callback();
      }
    };
    return {
      companyIdList: [],
      departmentList: [],
      positionList: [],
      formValidate: {
        name: "",
        position: "",
        department: "",
        fullName: "",
        companyId: "",
        email: "",
        password: "",
        confirmPassword: "",
        phone: "",
        mfaStatus: 0,
        code: ""
      },
      disabled: false,
      text: "",
      msgCode: "",
      areaCode: 86,
      run: null,
      AreaCodeArr: [],
      ruleValidate: {
        name: [
          { required: true, message: this.$t("permission_configuration_management.user.pleaseInputUserName"), trigger: "blur" },
          {
            message: this.$t("permission_configuration_management.user.userNameRule420"),
            pattern: "^[A-Za-z0-9]{4,20}$",
            trigger: "blur"
          }
        ],
        position: [
          {
            required: true,
            message: this.$t("permission_configuration_management.user.pleaseSelectPosition"),
            trigger: "change",
            type: "number"
          }
        ],
        department: [
          {
            required: true,
            message: this.$t("permission_configuration_management.user.pleaseSelectDepartment"),
            trigger: "change",
            type: "number"
          }
        ],
        companyId: [
          {
            required: true,
            message: this.$t("permission_configuration_management.user.pleaseSelectCompany"),
            trigger: "change",
            type: "number"
          }
        ],
        fullName: [
          { required: true, message: this.$t("permission_configuration_management.user.pleaseInputFullName"), trigger: "blur" },
          {
            message: this.$t("permission_configuration_management.user.fullNameRule250"),
            pattern: "^(?! )(?!.*? $)[ \u4e00-\u9fa5_a-zA-Z_]{2,50}$",
            trigger: "blur"
          }
        ],
        email: [
          { required: true, message: this.$t("permission_configuration_management.user.pleaseInputEmail"), trigger: "blur" },
          { type: "email", message: this.$t("permission_configuration_management.user.emailFormatError"), trigger: "blur" }
        ],
        password: [
          { required: true, validator: pwdValidate, trigger: "blur" },
          {
            message: this.$t("permission_configuration_management.user.passwordRule"),
            pattern: "^(?=.*[0-9].*)(?=.*[A-Z].*)(?=.*[a-z].*).{8,20}$",
            trigger: "blur"
          }
        ],
        confirmPassword: [
          { required: true, validator: pwdCheckValidate, trigger: "blur" },
          {
            message: this.$t("permission_configuration_management.user.passwordRule"),
            pattern: "^(?=.*[0-9].*)(?=.*[A-Z].*)(?=.*[a-z].*).{8,20}$",
            trigger: "blur"
          }
        ]
      }
    };
  },
  beforeCreate: function() {
    tableCaseVue = this;
  },
  mounted() {
    // 接收login页面传来的数组
    this.companyIdList = this.$route.query.companyIdList;
    this.departmentList = this.$route.query.departmentList;
    // 重定向页面
    this.$router.replace("/register");
    this.msgCode = this.$t("common.no");
    this.AreaCodeArr = AreaCode.list;
    this.text = this.$t(
      "permission_configuration_management.smsLogin.getVerificationCode"
    );
    clearInterval(this.run);
    this.disabled = false;
  },
  methods: {
    sendCode() {
      if (!this.formValidate.phone) {
        this.$Message.error(
          this.$t("permission_configuration_management.smsLogin.plaTelPhone")
        );
        return;
      }
      this.$api.user
        .sendSmsCode({
          id: "",
          phone: this.areaCode + "-" + this.formValidate.phone
        })
        .then(res => {
          this.countDown();
        })
        .catch(err => {});
    },
    countDown() {
      if (this.disabled) return;
      this.disabled = true;
      let n = 60;
      this.text =
        n +
        "s" +
        this.$t("permission_configuration_management.smsLogin.surplusTime");
      this.run = setInterval(() => {
        n = n - 1;
        if (n < 1) {
          this.disabled = false;
          this.text = this.$t(
            "permission_configuration_management.smsLogin.Reacquire"
          );
          clearInterval(this.run);
          return;
        }
        this.text =
          n +
          "s" +
          this.$t("permission_configuration_management.smsLogin.surplusTime");
        if (
          this.text <
          0 +
            "s" +
            this.$t("permission_configuration_management.smsLogin.surplusTime")
        ) {
          this.disabled = false;
          this.text = this.$t(
            "permission_configuration_management.smsLogin.Reacquire"
          );
        }
      }, 1000);
    },
    // 注册
    register: function(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          this.formValidate.mfaStatus =
            this.msgCode == this.$t("common.yes") ? 1 : 0;
          if (this.formValidate.mfaStatus == 1) {
            // 如果开启短信验证 手机号码为必填项
            if (!this.formValidate.phone) {
              this.$Message.error(
                this.$t(
                  "permission_configuration_management.smsLogin.plaTelPhone"
                )
              );
              return;
            }
            // 如果开启短信验证 验证码为必填项
            if (!this.formValidate.code) {
              this.$Message.error(
                this.$t(
                  "permission_configuration_management.smsLogin.plaVerificationCode"
                )
              );
              return;
            }
          }
          this.registerData();
        } else {
          this.$Message.error(this.$t("permission_configuration_management.user.registerFail"));
        }
      });
    },
    registerData() {
      this.$api.user
        .register({
          name: this.formValidate.name,
          email: this.formValidate.email,
          position: this.formValidate.position,
          department: this.formValidate.department,
          fullName: this.formValidate.fullName,
          password: this.formValidate.password,
          companyId: this.formValidate.companyId,
          mfaStatus: this.formValidate.mfaStatus,
          phone: this.areaCode + "-" + this.formValidate.phone,
          id: "",
          code: this.formValidate.code
        })
        .then(res => {
          clearInterval(this.run);
          this.disabled = false;
          this.text = this.$t(
            "permission_configuration_management.smsLogin.getVerificationCode"
          );
          // this.$router.replace("/login");
          window.location.href = `${global.SSO_PORTAL}/cmc/#/login`
          this.$Message.success(this.$t("permission_configuration_management.user.registerSuccess"));
        })
        .catch(err => {
          return;
        });
    },
    // 已有账号登录
    login: function() {
      // this.$router.replace("/login");
      window.location.href = `${global.SSO_PORTAL}/cmc/#/login`
    },

    // department change事件，根据department获取position列表
    changeDepartment: function() {
      this.listPositionByDepartmentRegister();
    },
    listPositionByDepartmentRegister: function() {
      this.$api.user
        .listPositionByDepartmentRegister({
          language: localStorage.getItem("locale"),
          departmentIndex: this.formValidate.department
        })
        .then(res => {
          this.positionList = res.data;
        });
    }
  }
};
</script>
<style scoped>
.overflow-register::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 4px; /*高宽分别对应横竖滚动条的尺寸*/
  height: 1px;
}
.overflow-register::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  /* border-radius: 10px;
  background-color: #5e6f76;
  background-image: -webkit-linear-gradient(
    45deg,
    rgba(255, 255, 255, 0.2) 25%,
    transparent 25%,
    transparent 50%,
    rgba(255, 255, 255, 0.2) 50%,
    rgba(255, 255, 255, 0.2) 75%,
    transparent 75%,
    transparent
  ); */
  border-radius: 10px;
  box-shadow: inset 0 0 5px rgba(97, 184, 179, 0.1);
  background: #b1b6bf;
}
.overflow-register::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  /* box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: #ededed;
  border-radius: 10px; */
  box-shadow: inset 0 0 5px rgba(87, 175, 187, 0.1);
  border-radius: 10px;
  background: #ededed;
}
.register {
  position: fixed;
  left: 0;
  right: 0;
  background-color: #2d3a4b;
  top: 0;
  bottom: 0;
}
.overflow-register {
  width: 463px;
  height: 550px;
  overflow: auto;
  padding-right: 10px;
}
.register-content {
  width: 448px;
  /* height: 362px; */
  margin-top: -261px;
  margin-left: -181px;
  position: fixed;
  top: 38%;
  left: 47%;
}

.register-title {
  font-size: 26px;
  color: #eee;
  margin: 0px auto 14px auto;
  text-align: center;
  font-weight: bold;
}

.register-user {
  border: 1px solid rgba(255, 255, 255, 0.1);
  background: rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  color: #454545;
  line-height: 52px;
  height: 52px;
  font-size: 14px;
  margin-bottom: 18px;
}

.register-user input {
  background: transparent;
  border: 0px;
  -webkit-appearance: none;
  border-radius: 0px;
  padding: 12px 5px 12px 15px;
  color: #eee;
  height: 47px;
  width: 395px;
  outline: none;
}

.register-icon {
  padding-left: 13px;
  color: #889aa4;
  font-size: 18px;
  margin-top: -4px;
}

.register-content button:not(.btn-text) {
  width: 100%;
  height: 40px;
  font-size: 14px;
  margin-bottom: 22px;
}
.btn-text {
  background: none;
  color: #c5c8ce;
}
.btn-text:hover {
  background: none;
}
.registers {
  font-size: 14px;
  color: #fff;
  cursor: pointer;
  width: 100%;
}

.register-content >>> .ivu-select-selection {
  background: transparent;
  border: 0;
  box-shadow: none;
}

.register-content >>> .ivu-select-selected-value {
  color: #fff;
}

.register-content >>> .ivu-select-arrow {
  position: absolute;
  top: 50%;
  right: 8px;
  line-height: 1;
  transform: translateY(-50%);
  font-size: 14px;
  color: #808695;
  transition: all 0.2s ease-in-out;
}

.register-content >>> .ivu-select-placeholder {
  color: #707070;
}
.msg-open {
  font-size: 18px;
  color: #889aa4;
  padding-left: 13px;
  vertical-align: -webkit-baseline-middle;
}
.tel-container {
  display: flex;
  align-items: center;
  height: 52px;
}

.tel-container >>> .ivu-select-single .ivu-select-selection {
  background: none;
  border: none;
  outline: none;
  border: none;
}
/* 去掉点击下拉框时的阴影 */
.tel-container >>> .ivu-select-single .ivu-select-selection:focus {
  box-shadow: 0 0 02px transparent;
}
.tel-container >>> .ivu-select-selected-value {
  color: #c5c8ce;
  text-align: center;
}
.tel-container
  >>> .ivu-select-single
  .ivu-select-selection
  .ivu-select-placeholder {
  color: #c5c8ce;
  text-align: center;
}
.tel-container >>> .ivu-select {
  width: 70px;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
input[type="number"] {
  -moz-appearance: textfield;
}
.tel-login-user >>> input::-webkit-outer-spin-button,
.tel-login-user >>> input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
.tel-login-user >>> input[type="number"] {
  -moz-appearance: textfield;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/permissions_configuration_management/user/Register.vue